class GiftCardRecipient extends HTMLElement {
  connectedCallback() {
    this._recipientCheckbox = this.querySelector('[name="properties[__shopify_send_gift_card_to_recipient]"]');
    this._recipientFieldsContainer = this.querySelector('.gift-card-recipient__fields');
    this._offsetProperty = this.querySelector('[name="properties[__shopify_offset]"]');
    this._recipientSendOnProperty = this.querySelector('[name="properties[Send on]"]');
    this._recipientOtherProperties = Array.from(this.querySelectorAll('[name*="properties"]')).filter(
      (input) => input.name !== 'properties[__shopify_send_gift_card_to_recipient]'
    );

    if (this._offsetProperty) {
      this._offsetProperty.value = new Date().getTimezoneOffset().toString();
    }

    if (this._recipientSendOnProperty) {
      const minDate = new Date();
      const maxDate = new Date();
      maxDate.setDate(minDate.getDate() + 90);
      this._recipientSendOnProperty.setAttribute('min', this._formatDate(minDate));
      this._recipientSendOnProperty.setAttribute('max', this._formatDate(maxDate));
    }

    if (this._recipientCheckbox) {
      this._recipientCheckbox.addEventListener('change', () => this._synchronizeProperties());
    }

    this._synchronizeProperties();
  }

  _synchronizeProperties() {
    const isChecked = this._recipientCheckbox && this._recipientCheckbox.checked;
    this._recipientOtherProperties.forEach((property) => (property.disabled = !isChecked));
    if (this._recipientFieldsContainer) {
      this._recipientFieldsContainer.classList.toggle('js-hidden', !isChecked);
    }
  }

  _formatDate(date) {
    const offset = date.getTimezoneOffset();
    const offsetDate = new Date(date.getTime() - offset * 60 * 1000);
    return offsetDate.toISOString().split('T')[0];
  }
}

if (!window.customElements.get('gift-card-recipient')) {
  window.customElements.define('gift-card-recipient', GiftCardRecipient);
}
